import SoftwareVersion from '../../enums/software-version';
import RestSet from '@common/interfaces/api/rest-set';

export interface StatsDeploymentSet {
  deploymentid: string;
  robotid: string;
  errors: { code: string; count: number }[];
  maintenances: { code: string; count: number }[];
  modes: { code: string; area: number; duration: number }[];
}

interface StatsMissionSet {
  data: StatsDeploymentSet[];
  rest: RestSet;
  buildNumber: string;
  softwareVersion: SoftwareVersion;
  count: number;
  start: string | null;
  end: string | null;
}

export interface StatsMissionResponse {
  data: StatsDeploymentSet[];
  count: number;
  start: string;
  end: string;
}

export enum RunReportFilterType {
  All,
  PositiveCleaning,
  OtherTypes,
}

export const POSITIVE_CLEANING_MODES = [
  'WallFollow',
  'SubZones',
  'Homing',
  'RepeatPath',
  'Random',
  'RandomWallFollow',
  // "HomeOnError",
  // "Failed",
  // "ZoneCleaning",
  // "Undock",
  // "SpotCleaning",
  'OpenSpaceWallFollow',
  'OpenSpace',
  // "DemoMode",
  // "EvacuateOnError",
  // "TeachPath",
];
export const REMOVED_CLEANING_MODES = ['Waiting', 'Charging', 'RemoteControl', 'Mapping'];

export const filterRunReports = (
  reports: { code: string; area: number; duration: number }[],
  returnType: RunReportFilterType,
) => {
  return reports.filter(
    (report) =>
      (returnType === RunReportFilterType.PositiveCleaning &&
        POSITIVE_CLEANING_MODES.some((cm) => cm === report.code)) ||
      (returnType === RunReportFilterType.OtherTypes &&
        !POSITIVE_CLEANING_MODES.some((cm) => cm === report.code) &&
        !REMOVED_CLEANING_MODES.some((cm) => cm === report.code)) ||
      (returnType === RunReportFilterType.All &&
        !REMOVED_CLEANING_MODES.some((cm) => cm === report.code)),
  );
};

export default StatsMissionSet;
